import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ProxyReversoErrorHandlerInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(
        (response) => {
          if (response instanceof HttpResponse && response.status === 210) {
            throw new HttpErrorResponse({ error: response.body.respostaOriginal, status: response.body.statusCode });
          }
        },
        error => {}
      )
    );
  }
}
